import * as Flex from '@twilio/flex-ui';
import transferOverride from './transferOverride';

export function setupActions(flexInstance: typeof Flex) {
  flexInstance.Actions.replaceAction('TransferTask', (payload, original) => {
    return transferOverride(payload, original);
  });
}
